import { Card, CardContent, View } from "@/components/ui";
import { links } from "@/constants";
import { Link } from "@/components/shared/link";
import { WarningCircle } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import type { CreditAccountType } from "@/types/profile";
import { getDepartmentCreditLabel } from "./utils";

export const CreditAccountInfo = ({ type }: { type: CreditAccountType }) => {
  const departmentLabel = getDepartmentCreditLabel(type);

  const creditTypeMsg =
    type === "general"
      ? "This credit can be used when paying invoices. "
      : `This credit can only be used for ${departmentLabel} Invoice. `;

  return (
    <Card className="border-primary-border bg-primary-surface" radius="xl">
      <CardContent className="px-4 py-3">
        <View className="native:max-w-[300px] flex w-full flex-row items-center gap-1">
          <WarningCircle weight="fill" className="text-primary" size={20} />
          <Typography color="secondary-text" variant="caption-md">
            {creditTypeMsg}
            <Link
              href={links.applyCreditHelpCentreLink}
              className="ml-1 text-primary"
            >
              Learn more
            </Link>
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
